var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 192V0h192v192z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.875 26.875h111.36v126.719H26.874z",
    fill: "#1976d2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.234 30.719h3.844v119.047h-3.844zm15.36 0h3.843v119.047h-3.843zm15.359 0h3.844v119.047h-3.844zm15.36 0h3.843v119.047h-3.844zm15.375 0h3.828v119.047h-3.829zm15.359 0h3.828v119.047h-3.828z",
    fill: "#42a5f5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.719 42.234h103.687v3.844H30.72zm0 15.36h103.687v3.843H30.72zm0 15.359h103.687v3.844H30.72zm0 15.36h103.687v3.843H30.72zm0 15.375h103.687v3.828H30.72zm0 15.359h103.687v3.828H30.72zm0 15.359h103.687v3.828H30.72z",
    fill: "#42a5f5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.234 153.594V58.266l-83.812 83.812 11.515 11.516z",
    fill: "#1565c0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138.234 153.594v-38.39l-38.39 38.39z",
    fill: "#1565c0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m65.281 142.078 76.797-76.797 23.031 23.032-76.797 76.812z",
    fill: "#ffa000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m135.203 72.156 6.953 6.969-5.437 5.422-6.953-6.953zm-.719 26.172-5.437 5.422-12.719-12.719 5.422-5.422zm-26.89 26.875-5.422 5.438-12.719-12.735 5.422-5.422zM88.39 132.89l-5.421 5.423L76 131.358l5.438-5.437zM115.281 106l-5.437 5.438-6.953-6.97 5.421-5.421z",
    fill: "#9e6400"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m59.844 136.656-2.25 2.25v6.36l2.25 2.25 1.593 1.578v-10.86h7.688l3.828-3.828h-10.86zm43.844 13.11h3.828v-3.844zm30.718-26.891v-3.828l-3.844 3.828zm-11.531 26.891v-11.532h11.531v-3.828h-11.531v-3.844l-7.672 7.672h3.844v11.532zm-49.922-26.219v10.86l3.844-3.844v-7.688h7.687l3.828-3.828H77.453zm30.735-30.719v10.86l3.828-3.844v-7.688h7.687l3.844-3.844h-10.86zm-15.375 15.36v10.859l3.843-3.844v-7.687h7.688l3.844-3.828h-10.86zm30.734-30.735v10.86l3.828-3.829v-7.687h7.688l3.843-3.844h-10.86z",
    fill: "#1976d2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.f3228027fc6c4bea879ab03379885de5.svg";
export { ForwardRef as ReactComponent };